
<nav class="head-nav">
    <div class="nav-container">
        <div>
            <h2>{{ "restaurant.Kitchens" | translate }}</h2>
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <a [routerLink]='["/admin"]'>{{ "general.Home" | translate }}</a>
                </li>
                <li class="breadcrumb-item" *ngIf="restaurantId">
                    <a class="breadcrumb-restaurant-name" [routerLink]='["/admin/restaurants/profile", restaurantId]'>{{restaurantData?.name}}</a>
                </li>
                <li class="breadcrumb-item">{{"restaurant.Floors & Kitchens" | translate}}</li>
                <li class="breadcrumb-item">{{ "restaurant.Kitchens" | translate }}</li>
            </ol>
        </div>
        <app-restaurants-dropdown (all)="restaurantId = $event; GetScreenData()"></app-restaurants-dropdown>
    </div>
</nav>
<div class="page">
    <div class="page-filters" [hidden]="dataLoading">
        <div class="sort-item">
            <span class="count-page font-16">
                <span>{{recordsData?.totalCount}}</span>
                {{'restaurant.Kitchens' | translate}}
            </span>
            <label>{{ 'general.Sorted by' | translate }}:</label>
            <select class="form-control" (change)="getAll(null, restaurantId)" [(ngModel)]="filterModel.sortItems">
                <option *ngFor="let sortItem of sortItems" [value]="sortItem.value">{{sortItem.name}}</option>
            </select>
        </div>

        <div class="filters-container">
            <div class="search-input">
                <mat-form-field appearance="legacy" *ngIf="showSearch">
                    <input matInput autocomplete="off" [(ngModel)]="filterModel.searchText"
                        (keydown.enter)="makeSearch()">
                    <mat-icon (click)="resetSearch(); showSearch = false;" matSuffix>clear</mat-icon>
                </mat-form-field>
                <button mat-icon-button (click)="makeSearch()">
                    <img src="./assets/images/icons/search.svg">
                </button>
            </div>

            <button (click)="showFilter = !showFilter" [ngClass]='{"active": showFilter}' class="btn dropdown-custom">
                <img src="./assets/images/icons/filter-outline.svg">
                <span>{{"general.Filter" | translate}}</span>
                <svg width="8" height="5.001" viewBox="0 0 8 5.001">
                    <path id="menu-icon" d="M-3.562-9.316-.5-6.215l3.062-3.1.938.949-4,4.051-4-4.051Z"
                        transform="translate(4.5 9.316)" fill="#6a6a6a" opacity="0.8" />
                </svg>
            </button>
            <div class="create-item">
                <a class="btn-light" mat-stroked-button
                (click)="openKitchenForm()"
                    *ngIf="recordsData?.canAdd && restaurantId">
                    <img src="./assets/images/icons/plus-ic.svg">
                    <span>{{"restaurant.Add Kitchen" | translate}}</span>
                </a>
            </div>
        </div>

        <div class="filter-section" [hidden]="!showFilter">
            <h4 class="title">{{"general.Filter by" | translate}}</h4>
            <div [formGroup]="filterFormGroup" class="row">
                <div class="col-lg-4 mb-3">
                    <mat-form-field class="no-validation">
                        <mat-label>{{"forms.Creation Date From" | translate}}</mat-label>
                        <input matInput [matDatepicker]="createdFrom" formControlName='createdFrom'
                            [max]="filterFormGroup.controls['createdTo'].value || today" readonly
                            (focus)="createdFrom.open()" (click)="createdFrom.open()">
                        <button mat-icon-button matSuffix *ngIf="filterFormGroup.controls['createdFrom'].value"
                            (click)="filterFormGroup.controls['createdFrom'].setValue(''); makeFilter();">
                            <mat-icon>close</mat-icon>
                        </button>
                        <mat-datepicker-toggle matSuffix [for]="createdFrom"></mat-datepicker-toggle>
                        <mat-datepicker #createdFrom></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-lg-4 mb-3">
                    <mat-form-field class="no-validation">
                        <mat-label>{{"forms.Creation Date To" | translate}}</mat-label>
                        <input matInput [matDatepicker]="createdTo" formControlName='createdTo'
                            [min]="filterFormGroup.controls['createdFrom'].value" readonly [max]='today'
                            (focus)="createdTo.open()" (click)="createdTo.open()">
                        <button mat-icon-button matSuffix *ngIf="filterFormGroup.controls['createdTo'].value"
                            (click)="filterFormGroup.controls['createdTo'].setValue(''); makeFilter();">
                            <mat-icon>close</mat-icon>
                        </button>
                        <mat-datepicker-toggle matSuffix [for]="createdTo"></mat-datepicker-toggle>
                        <mat-datepicker #createdTo></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>

            <div class="btn-container">
                <button mat-stroked-button color="primary" (click)="makeFilter()">{{"general.Apply Filter" |
                    translate}}</button>
                <button mat-stroked-button (click)="clearFilter()">{{"general.Clear Filter" | translate}}</button>
            </div>
        </div>
    </div>

    <div *ngIf='dataLoading' class="dataLoading">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
    </div>

    <ng-container *ngIf='!dataLoading'>
        <div *ngIf="recordsData?.pageData && recordsData?.pageData?.length; else dataEmpty">
            <div class="table-responsive table-container">
                <table class="table table-primary">
                  <thead>
                    <tr>
                        <th class="font-14 fontMedium">{{'restaurant.Kitchen Name' | translate}}</th>
                        <th class="font-14 fontMedium">{{'content3.Menu Items' | translate}}</th>
                        <th class="font-14 fontMedium">{{'restaurant.Staff Members' | translate}}</th>
                        <th class="font-14 fontMedium">{{'restaurant.Responsible Chef' | translate}}</th>
                        <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of recordsData?.pageData">
                        <td class="font-14 fontRegular">{{item.name}}</td>
                        <td class="font-14 fontRegular">
                            <span class="td-border-item font-14 fontMedium" *ngIf="item.menuItemCount"
                             (click)="openList(item.id, 1)">
                                <span>{{item.menuItemCount}} {{"forms.Items" | translate}}</span>
                                <mat-icon>keyboard_arrow_right</mat-icon>
                            </span>
                            <span *ngIf="!item.menuItemCount" class="font-14 fontRegular">{{'content4.N/A' | translate }}</span>
                        </td>
                        <td class="font-14 fontRegular">
                            <span class="td-border-item font-14 fontMedium" *ngIf="item.staffMemberCount" 
                            (click)="openList(item.id, 2)">
                                <span>{{item.staffMemberCount}} {{"restaurant.Members" | translate}}</span>
                                <mat-icon>keyboard_arrow_right</mat-icon>
                            </span>
                            <span *ngIf="!item.staffMemberCount" class="font-14 fontRegular">{{'content4.N/A' | translate }}</span>
                        </td>
                        <td class="font-14 fontRegular">
                            <div class="name-with-image small" *ngIf="item.responseChefName">
                                <div class="image-circle">
                                    <img *ngIf="item.responseCheficon" [src]="item.responseCheficon" (error)='item.responseCheficon = ""'>
                                    <span *ngIf="!item.responseCheficon">{{ item.responseChefName | shortName }}</span>
                                </div>
                                <div class="name">
                                    {{item.responseChefName}}
                                </div>
                            </div>
                            <span *ngIf="!item.responseChefName" class="font-14 fontRegular">{{'content4.N/A' | translate }}</span>
                        </td>
                        <td>
                            <div class="btn-actions">

                                <button type="button" mat-icon-button [matTooltip]="'general.Edit' | translate"
                                    (click)="openKitchenForm(item)" *ngIf="item.canEdit">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <button type="button" mat-icon-button
                                    [matTooltip]="'general.Delete' | translate" (click)="deleteRecord(item.id)"
                                    *ngIf="item.canDelete">
                                    <mat-icon class="delete-icon">delete</mat-icon>
                                </button>

                            </div>
                        </td>
                    </tr>
                </tbody>
        
                </table>
              </div>

            <div class="pagination-container" *ngIf="recordsData && (pageCount > 1 || recordsData['totalCount'] > pageSize)">
                <mat-paginator [length]="recordsData['totalCount']" [pageSize]="filterModel.pageSize"
                    [pageSizeOptions]="[5, 10, 20]" (page)="getAll($event, restaurantId)" [pageIndex]="pageIndex"></mat-paginator>
            </div>

        </div>

        <ng-template #dataEmpty>
            <empty-state [title]='"restaurant.Kitchens list is empty" | translate'
                [img]="'/assets/images/icons/kitchen-empty.svg'"></empty-state>
        </ng-template>
    </ng-container>
</div>